import React from "react";
import { motion } from "framer-motion";

// O ícone foi movido para dentro deste arquivo para resolver o erro de importação.
const SparklesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4m-2 2h2m5-4l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
);

function Experience() {
    const projetos = [
        "Primeira certificação GPTW em empresas de saúde e tecnologia",
        "Implantação completa dos subsistemas de Gestão de Pessoas",
        "Criação da Universidade Corporativa em holding de saúde",
        "Desenvolvimento de programas de saúde e liderança",
        "Implantação de Programa de Integridade & Código de Ética",
        "Coautora do livro 'O Protagonismo das Mulheres na Liderança' (2025)"
    ];

    return (
        <section id="experience" className="py-20 bg-brand-bege">
            <div className="container mx-auto px-6">
                <h2 className="text-3xl font-bold text-center mb-12 text-brand-grafite font-montserrat">Projetos e Entregas Relevantes</h2>
                <motion.ul
                    className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ staggerChildren: 0.1, duration: 0.5 }}
                    viewport={{ once: true }}
                >
                    {projetos.map((item, index) => (
                        <motion.li
                            key={index}
                            className="bg-white p-6 rounded-lg shadow-sm flex items-start"
                            variants={{
                                hidden: { opacity: 0, y: 20 },
                                visible: { opacity: 1, y: 0 },
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <div className="flex-shrink-0 text-brand-savia mr-4"><SparklesIcon /></div>
                            <span className="text-brand-grafite/90">{item}</span>
                        </motion.li>
                    ))}
                </motion.ul>
            </div>
        </section>
    );
}

export default Experience;

